<template>
  <div id="skill-list">
    <v-card>
      <v-card-title primary-title class="amber lighten-1">
        <v-layout align-baseline justify-space-between>
          <h3 class="headline pb-2 blue--text text--darken-4"><v-icon color="blue darken-4">build</v-icon> Compétences</h3>
          <SectionsLayout
            :cv_id='cv_id'
            section='skillcat'
          >
          </SectionsLayout>
        </v-layout>
      </v-card-title>

        <v-expansion-panel popout>
          <v-layout>
            <v-flex xs12>
              <transition-group name="list-item">
                <v-expansion-panel-content
                  v-for="(item, index) in modelObjects" :key="item.id"
                  hide-actions
                >
                  <div slot="header">

                    <v-layout align-start justify-space-between class="my-1">
                      <v-flex py-0 my-0>
                        <h4 v-if="item.title" class="title font-weight-regular">{{ item.title }}</h4>
                        <h4 v-else class="title font-weight-regular">Nouvelle Catégorie de Compétences</h4>
                      </v-flex>

                      <v-flex py-0 my-0>
                        <itemBar
                          :item="item"
                          :index="index"
                          v-on:update-item="updateModelObject"
                          v-on:delete-item="deleteModelObject"
                          v-on:pullup-item="pullUpItem"
                          v-on:pulldown-item="pullDownItem"
                        >
                        </itemBar>
                      </v-flex>
                    </v-layout>

                      <!-- <div class="d-inline-flex ">
                        <h6 class="subheading" v-if="item.institution"> {{ item.institution }} :</h6>
                        <h6 v-if="item.start_year" class="subheading ml-2"> {{ item.start_year }} </h6>
                        <h6 v-if="item.end_year" class="subheading ml-2"> - {{ item.end_year }} </h6>
                        <h6 v-else class="subheading ml-2"> à aujourd'hui</h6>
                      </div> -->

                  </div>

                  <SkillComponent
                    :isLoading="isLoading"
                    :itemCollapseShow="itemCollapseShow"
                    :item="item"
                    :index="index"
                    :arraylen="modelObjects.length"
                    :cv_id="cv_id"

                    v-on:delete-item="deleteModelObject"
                    v-on:update-item="updateModelObject"

                  ></SkillComponent>

                </v-expansion-panel-content>
              </transition-group>
            </v-flex>
          </v-layout>
        </v-expansion-panel>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-btn outline round color="info" v-on:click="addModelObject(); showIt()">
            <v-icon left>add_circle_outline</v-icon>
            Ajouter une catégorie de compétences
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>

</template>


<script>

import { mixin_ajax } from './mixin_ajax_vue.js';
import { mixin_pullupdown } from './mixin_pullupdown.js';
import SkillComponent from './SkillComponent';
import SectionsLayout from '../components/SectionsLayout';
import ItemBar from '../components/ItemBar';

export default {
  mixins: [mixin_ajax, mixin_pullupdown],
  props: ['cv_id'],
  components: {
    SkillComponent,
    SectionsLayout,
    ItemBar,
  },
  data: function() {
    return {
      dialog: {},
      api_url: '/api/' + this.cv_id + '/skillcat/',
      modelObjects: [],
      newModelObject: function() {
        return {
          'display_order': this.modelObjects.length,
          'curriculum': this.cv_id,
        }
      },
      isLoading: false,
    }
  },
}


</script>

<style>

</style>
